var map = {
	"./AboutScreenDesktop.png": "760c",
	"./AboutScreenMobile.png": "2474",
	"./AdvertiseWithKrishify.png": "53de",
	"./EngageDirectly.png": "736e",
	"./IntroCard.png": "9bf1",
	"./MarketIntelligence.png": "0c44",
	"./ReachUsForm/reachusImage.png": "4716",
	"./StartSelling.png": "7bf2",
	"./adressIcon.svg": "5b17",
	"./backButton.svg": "f57a",
	"./footerIcons/Email.png": "671f",
	"./footerIcons/adressIcon.png": "67b7",
	"./footerIcons/facebook.png": "5158",
	"./footerIcons/instagram.png": "0b39",
	"./footerIcons/linkedin.png": "a27c",
	"./footerIcons/twitter.png": "7550",
	"./footerIcons/youtube.png": "a4fe",
	"./greeenTick.svg": "cd52",
	"./headerBackground.png": "a1cf",
	"./image.png": "4ec5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8164";